import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: 'image-1',
        category: 'Ажил',
        title: 'GARIDMEBEL.MN тавилгын компанийн вэб сайт'
    },
    {
        image: 'image-2',
        category: 'Ажил',
        title: 'MONGOLSANDWICH.COM үндэсний үйлдвэрлэгч компанийн вэб сайт'
    },
    {
        image: 'image-3',
        category: 'Ажил',
        title: 'TRAVELMGL.COM аялал жуулчлалын вэб сайт'
    },
    {
        image: 'image-4',
        category: 'Ажил',
        title: 'Алтан бэрс ХХК сошиал медиа маркетингийн үйлчилгээ '
    },
    {
        image: 'image-3',
        category: 'Ажил',
        title: 'Сахар бууруулагч" үндэсний брэнд цайны пост түгээ'
    },
    {
        image: 'image-4',
        category: 'Ажил',
        title: 'Deluxe beauty lounge-ийн пэйже хуудас хөтлөлт, зөв '
    }
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><a href="/portfolio-details">{value.title}</a></h4>
                                    <div className="portfolio-button">
                                        <a className="rn-btn" href="/portfolio-details">Дэлгэрэнгүй</a>
                                    </div>
                                </div>
                            </div>
                            <Link className="link-overlay" to="/portfolio-details"></Link>
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;